import API from '../../utils/Api'
import Router from '@/router'
import Vue from '@/main'
import i18n from '@/plugins/i18n'

const api = new API('games')

const state = {
  token: '',
  auth: false,
  loading: false
}

const getters = {
  loading: state => state.loading
}

const actions = {
  async checkIfAlreadyAuth({ commit, state }) {
    try {
      if (state.auth) {
        Router.replace('/')
      }
    } catch (error) {
      commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
    }
  },

  async login({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.post(params, '/join/' + params.code + '/' + params.account)
      commit('SET_user', res.data)
      commit('company/SET_company', res.data.company, { root: true })
      commit('game/SET_game', res.data.game, { root: true })
      Vue.$vuetify.theme.themes.light.primary = res.data.game.gameVersion.style.colors.primary
      Vue.$vuetify.theme.themes.light.secondary = res.data.game.gameVersion.style.colors.secondary
      Vue.$i18n.locale = res.data.game.params.lang
      Vue.$vuetify.lang.current = res.data.game.params.lang
      commit('interfaceSettings/SET_account', params.account, { root: true })
      commit('interfaceSettings/SET_notification', {success: true, message : i18n.t('user.welcome') + res.data.game.name}, { root: true })
      commit('SET_loading', false)
      Router.push('/')
    } catch (error) {
      commit('SET_loading', false)
      if (error.response.data.code) {
        switch (error.response.data.code) {
          case "1":
            commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.noParties')}, { root: true })
            break;
  
          case "2":
            commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.notOpen')}, { root: true })
            break;
        
          case "3":
            commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.noMorePlace')}, { root: true })
            break;
        }  
      } else {
        commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
      }
    }
  },

  async rejoin({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.post(params, '/rejoin')
      commit('SET_user', res.data)
      commit('company/SET_company', res.data.company, { root: true })
      commit('game/SET_game', res.data.game, { root: true })
      Vue.$vuetify.theme.themes.light.primary = res.data.game.gameVersion.style.colors.primary
      Vue.$vuetify.theme.themes.light.secondary = res.data.game.gameVersion.style.colors.secondary
      Vue.$i18n.locale = res.data.game.params.lang
      Vue.$vuetify.lang.current = res.data.game.params.lang
      commit('interfaceSettings/SET_account', params.account, { root: true })
      commit('interfaceSettings/SET_notification', {success: true, message : i18n.t('user.welcome') + res.data.game.name}, { root: true })
      commit('SET_loading', false)
      Router.push('/')
    } catch (error) {
      commit('SET_loading', false)
      if (error.response.data.code) {
        switch (error.response.data.code) {
          case "1":
            commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.noParties')}, { root: true })
            break;
  
          case "2":
            commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.notOpen')}, { root: true })
            break;
        
          case "3":
            commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.noMorePlace')}, { root: true })
            break;
        }  
      } else {
        commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
      }
    }
  },

  async askRejoin({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.post(params, '/ask-rejoin/')
      commit('interfaceSettings/SET_account', params.account, { root: true })
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
    }
  },
  
  async logout({ commit, rootState }) {
    try {
      if (rootState.game.data && rootState.game.data._id) {
        Vue.$socket.emit("unsubscribe", rootState.game.data._id);
      }
      commit('UNSET_user')
      commit('company/SET_company', null, { root: true })
      commit('game/SET_game', null, { root: true })
      Vue.$vuetify.theme.themes.light.primary = "#1976d2"
      Vue.$vuetify.theme.themes.light.secondary = "#424242"
      Vue.$i18n.locale = 'fr'
      Vue.$vuetify.lang.current = 'fr'
      commit('interfaceSettings/SET_instructionStep', 1, { root: true })
      Router.push('/login')
    } catch (error) {
      commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
    }
  },

  async sessionExpired({ commit, dispatch }) {
    await dispatch('logout')
    commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('user.sessionExpired')}, { root: true })
  }
}

const mutations = {
  UNSET_user(state) {
    state.token = null
    state.auth = false
  },
  SET_user(state, params) {
    state.auth = true
    state.token = params.token
  },
  SET_loading(state, val) {
    state.loading = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}